export default {
  data() {
    return {
      couponCode: '',
    };
  },
  methods: {
    async addCoupon() {
      if (this.couponCode.length !== '') {
        const loader = this.$loading.show();

        try {
          const response = await this.axios.get(
              `/v2/coupons/${this.couponCode}?total=${this.tmpOrder.total_price}`);

          if (response.data.success) {
            const data = {
              form: {
                coupon_id: response.data.data.id,
              },
              cart: JSON.stringify(this.cart),
            };

            const tmpOrder = await this.axios.put(
                `v2/temp-order/${this.checkout.authType}/${this.tmpOrder.id}`,
                data);

            if (tmpOrder.data.success) {
              tmpOrder.data.data.flags = response.data.flags;
              this.$store.dispatch('SET_TMP_ORDER', tmpOrder.data.data);
            } else {
              this.toast(this.$t('error'), tmpOrder.data.message, 'danger');
            }

            this.$bvToast.hide();

            this.couponCode = '';
            this.toast(this.$t('success'), response.data.message, 'success');

            const checkout = this.checkout;
            checkout.coupon = response.data.data;

            if (tmpOrder.data.data && +tmpOrder.data.data.grandtotal === 0) {
              checkout.paymentOption = null;

              this.$store.dispatch('SET_CHECKOUT', checkout);
              this.$store.dispatch('SET_CHECKOUT_STEP', 6);
            } else {
              this.$store.dispatch('SET_CHECKOUT', checkout);
              this.$store.dispatch('SET_CHECKOUT_STEP', this.checkoutStep + 1);
            }
          } else {
            this.toast(this.$t('error'), response.data.message, 'danger');
          }

          loader.hide();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          loader.hide();
        }
      }
    },
  },
  created() {
    this.$emit('info', this.$t('coupon'));

    if (this.checkout) {
      this.showRandomCouponBanner();
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  },
};
